import { Suspense, lazy } from 'react';
// components
import { LoadingScreen } from '../components/loading-screen';

// ----------------------------------------------------------------------

const Loadable = (Component) => (props) =>
  (
    <Suspense fallback={<LoadingScreen />}>
      <Component {...props} />
    </Suspense>
  );

// ----------------------------------------------------------------------

// AUTH
export const LoginPage = Loadable(lazy(() => import('../pages/auth/LoginPage')));
export const RegisterPage = Loadable(lazy(() => import('../pages/auth/RegisterPage')));
export const VerifyCodePage = Loadable(lazy(() => import('../pages/auth/VerifyCodePage')));
export const NewPasswordPage = Loadable(lazy(() => import('../pages/auth/NewPasswordPage')));
export const ResetPasswordPage = Loadable(lazy(() => import('../pages/auth/ResetPasswordPage')));

// DASHBOARD: GENERAL
export const GeneralAppPage = Loadable(lazy(() => import('../pages/dashboard/GeneralAppPage')));

// MANAGEMENT

//  common-dynamic-module
export const CommonDynamicModuleListPage = Loadable(
  lazy(() => import('../pages/dashboard/common-dynamic-module/CommonDynamicModuleListPage'))
);
export const CommonDynamicModuleCreatePage = Loadable(
  lazy(() => import('../pages/dashboard/common-dynamic-module/CommonDynamicModuleCreatePage'))
);
export const CommonDynamicModuleEditPage = Loadable(
  lazy(() => import('../pages/dashboard/common-dynamic-module/CommonDynamicModuleEditPage'))
);
export const CommonDynamicModuleViewPage = Loadable(
  lazy(() => import('../pages/dashboard/common-dynamic-module/CommonDynamicModuleViewPage'))
);

//  Staff
export const StaffManagementListPage = Loadable(
  lazy(() => import('../pages/dashboard/management/staff-management/StaffManagementListPage'))
);
export const StaffManagementCreatePage = Loadable(
  lazy(() => import('../pages/dashboard/management/staff-management/StaffManagementCreatePage'))
);
export const StaffManagementEditPage = Loadable(
  lazy(() => import('../pages/dashboard/management/staff-management/StaffManagementEditPage'))
);
export const StaffManagementViewPage = Loadable(
  lazy(() => import('../pages/dashboard/management/staff-management/StaffManagementViewPage'))
);

//  Product
export const ProductManagementListPage = Loadable(
  lazy(() => import('../pages/dashboard/management/product-management/ProductManagementListPage'))
);
export const ProductManagementCreatePage = Loadable(
  lazy(() => import('../pages/dashboard/management/product-management/ProductManagementCreatePage'))
);
export const ProductManagementEditPage = Loadable(
  lazy(() => import('../pages/dashboard/management/product-management/ProductManagementEditPage'))
);
export const ProductManagementViewPage = Loadable(
  lazy(() => import('../pages/dashboard/management/product-management/ProductManagementViewPage'))
);

// Doctor
export const DoctorManagementListPage = Loadable(
  lazy(() => import('../pages/dashboard/management/doctor-management/DoctorManagementListPage'))
);
export const DoctorManagementCreatePage = Loadable(
  lazy(() => import('../pages/dashboard/management/doctor-management/DoctorManagementCreatePage'))
);
export const DoctorManagementEditPage = Loadable(
  lazy(() => import('../pages/dashboard/management/doctor-management/DoctorManagementEditPage'))
);
export const DoctorManagementViewPage = Loadable(
  lazy(() => import('../pages/dashboard/management/doctor-management/DoctorManagementViewPage'))
);

//  Project
export const ProjectManagementListPage = Loadable(
  lazy(() => import('../pages/dashboard/management/project-management/ProjectManagementListPage'))
);
export const ProjectManagementCreatePage = Loadable(
  lazy(() => import('../pages/dashboard/management/project-management/ProjectManagementCreatePage'))
);
export const ProjectManagementEditPage = Loadable(
  lazy(() => import('../pages/dashboard/management/project-management/ProjectManagementEditPage'))
);
export const ProjectManagementViewPage = Loadable(
  lazy(() => import('../pages/dashboard/management/project-management/ProjectManagementViewPage'))
);

//  Job Listing
export const JobListPage = Loadable(
  lazy(() => import('../pages/dashboard/management/job-listing/JobListPage'))
);
export const JobCreatePage = Loadable(
  lazy(() => import('../pages/dashboard/management/job-listing/JobCreatePage'))
);
export const JobEditPage = Loadable(
  lazy(() => import('../pages/dashboard/management/job-listing/JobEditPage'))
);
export const JobViewPage = Loadable(
  lazy(() => import('../pages/dashboard/management/job-listing/JobViewPage'))
);

//  QR Code Manager
export const QRCodeManagerListPage = Loadable(
  lazy(() => import('../pages/dashboard/management/qr-code-manager/QRCodeManagerListPage'))
);
export const QRCodeManagerCreatePage = Loadable(
  lazy(() => import('../pages/dashboard/management/qr-code-manager/QRCodeManagerCreatePage'))
);
export const QRCodeManagerEditPage = Loadable(
  lazy(() => import('../pages/dashboard/management/qr-code-manager/QRCodeManagerEditPage'))
);
export const QRCodeManagerViewPage = Loadable(
  lazy(() => import('../pages/dashboard/management/qr-code-manager/QRCodeManagerViewPage'))
);

// COMMUNICATION

//  Banner
export const BannerListPage = Loadable(
  lazy(() => import('../pages/dashboard/communication/banner/BannerListPage'))
);
export const BannerCreatePage = Loadable(
  lazy(() => import('../pages/dashboard/communication/banner/BannerCreatePage'))
);
export const BannerEditPage = Loadable(
  lazy(() => import('../pages/dashboard/communication/banner/BannerEditPage'))
);
export const BannerViewPage = Loadable(
  lazy(() => import('../pages/dashboard/communication/banner/BannerViewPage'))
);

//  Banner
export const DynamicFormEditPage = Loadable(
  lazy(() => import('../pages/dashboard/configuration/dynamic-form/DynamicFormEditPage'))
);

// CONFIGURATION

//  Gallery
export const GalleryListPage = Loadable(
  lazy(() => import('../pages/dashboard/communication/gallery/GalleryListPage'))
);
export const GalleryCreatePage = Loadable(
  lazy(() => import('../pages/dashboard/communication/gallery/GalleryCreatePage'))
);
export const GalleryEditPage = Loadable(
  lazy(() => import('../pages/dashboard/communication/gallery/GalleryEditPage'))
);
export const GalleryViewPage = Loadable(
  lazy(() => import('../pages/dashboard/communication/gallery/GalleryViewPage'))
);

//  Testimonial
export const TestimonialListPage = Loadable(
  lazy(() => import('../pages/dashboard/communication/testimonial/TestimonialListPage'))
);
export const TestimonialCreatePage = Loadable(
  lazy(() => import('../pages/dashboard/communication/testimonial/TestimonialCreatePage'))
);
export const TestimonialEditPage = Loadable(
  lazy(() => import('../pages/dashboard/communication/testimonial/TestimonialEditPage'))
);
export const TestimonialViewPage = Loadable(
  lazy(() => import('../pages/dashboard/communication/testimonial/TestimonialViewPage'))
);

//  Association
export const AssociationListPage = Loadable(
  lazy(() => import('../pages/dashboard/communication/association/AssociationListPage'))
);
export const AssociationCreatePage = Loadable(
  lazy(() => import('../pages/dashboard/communication/association/AssociationCreatePage'))
);
export const AssociationEditPage = Loadable(
  lazy(() => import('../pages/dashboard/communication/association/AssociationEditPage'))
);
export const AssociationViewPage = Loadable(
  lazy(() => import('../pages/dashboard/communication/association/AssociationViewPage'))
);

//  Post
export const PostListPage = Loadable(
  lazy(() => import('../pages/dashboard/communication/post/PostListPage'))
);
export const PostCreatePage = Loadable(
  lazy(() => import('../pages/dashboard/communication/post/PostCreatePage'))
);
export const PostEditPage = Loadable(
  lazy(() => import('../pages/dashboard/communication/post/PostEditPage'))
);
export const PostViewPage = Loadable(
  lazy(() => import('../pages/dashboard/communication/post/PostViewPage'))
);

// CONFIGURATION

//  Company Management
export const CompanyListPage = Loadable(
  lazy(() => import('../pages/dashboard/configuration/company-management/CompanyListPage'))
);
export const CompanyCreatePage = Loadable(
  lazy(() => import('../pages/dashboard/configuration/company-management/CompanyCreatePage'))
);
export const CompanyEditPage = Loadable(
  lazy(() => import('../pages/dashboard/configuration/company-management/CompanyEditPage'))
);
export const CompanyViewPage = Loadable(
  lazy(() => import('../pages/dashboard/configuration/company-management/CompanyViewPage'))
);

//  Qualification Level
export const QualificationLevelListPage = Loadable(
  lazy(() =>
    import('../pages/dashboard/configuration/qualification-level/QualificationLevelListPage')
  )
);
export const QualificationLevelCreatePage = Loadable(
  lazy(() =>
    import('../pages/dashboard/configuration/qualification-level/QualificationLevelCreatePage')
  )
);
export const QualificationLevelEditPage = Loadable(
  lazy(() =>
    import('../pages/dashboard/configuration/qualification-level/QualificationLevelEditPage')
  )
);
export const QualificationLevelViewPage = Loadable(
  lazy(() =>
    import('../pages/dashboard/configuration/qualification-level/QualificationLevelViewPage')
  )
);

//  Project Type
export const ProjectTypeListPage = Loadable(
  lazy(() => import('../pages/dashboard/configuration/project-type/ProjectTypeListPage'))
);
export const ProjectTypeCreatePage = Loadable(
  lazy(() => import('../pages/dashboard/configuration/project-type/ProjectTypeCreatePage'))
);
export const ProjectTypeEditPage = Loadable(
  lazy(() => import('../pages/dashboard/configuration/project-type/ProjectTypeEditPage'))
);
export const ProjectTypeViewPage = Loadable(
  lazy(() => import('../pages/dashboard/configuration/project-type/ProjectTypeViewPage'))
);

//  Country
export const CountryListPage = Loadable(
  lazy(() => import('../pages/dashboard/configuration/country/CountryListPage'))
);
export const CountryCreatePage = Loadable(
  lazy(() => import('../pages/dashboard/configuration/country/CountryCreatePage'))
);
export const CountryEditPage = Loadable(
  lazy(() => import('../pages/dashboard/configuration/country/CountryEditPage'))
);
export const CountryViewPage = Loadable(
  lazy(() => import('../pages/dashboard/configuration/country/CountryViewPage'))
);

//  State
export const StateListPage = Loadable(
  lazy(() => import('../pages/dashboard/configuration/state/StateListPage'))
);
export const StateCreatePage = Loadable(
  lazy(() => import('../pages/dashboard/configuration/state/StateCreatePage'))
);
export const StateEditPage = Loadable(
  lazy(() => import('../pages/dashboard/configuration/state/StateEditPage'))
);
export const StateViewPage = Loadable(
  lazy(() => import('../pages/dashboard/configuration/state/StateViewPage'))
);

//  City
export const CityListPage = Loadable(
  lazy(() => import('../pages/dashboard/configuration/city/CityListPage'))
);
export const CityCreatePage = Loadable(
  lazy(() => import('../pages/dashboard/configuration/city/CityCreatePage'))
);
export const CityEditPage = Loadable(
  lazy(() => import('../pages/dashboard/configuration/city/CityEditPage'))
);
export const CityViewPage = Loadable(
  lazy(() => import('../pages/dashboard/configuration/city/CityViewPage'))
);

//  Industry
export const IndustryListPage = Loadable(
  lazy(() => import('../pages/dashboard/configuration/industry/IndustryListPage'))
);
export const IndustryCreatePage = Loadable(
  lazy(() => import('../pages/dashboard/configuration/industry/IndustryCreatePage'))
);
export const IndustryEditPage = Loadable(
  lazy(() => import('../pages/dashboard/configuration/industry/IndustryEditPage'))
);
export const IndustryViewPage = Loadable(
  lazy(() => import('../pages/dashboard/configuration/industry/IndustryViewPage'))
);

//  Specialization
export const SpecializationListPage = Loadable(
  lazy(() => import('../pages/dashboard/configuration/specialization/SpecializationListPage'))
);
export const SpecializationCreatePage = Loadable(
  lazy(() => import('../pages/dashboard/configuration/specialization/SpecializationCreatePage'))
);
export const SpecializationEditPage = Loadable(
  lazy(() => import('../pages/dashboard/configuration/specialization/SpecializationEditPage'))
);
export const SpecializationViewPage = Loadable(
  lazy(() => import('../pages/dashboard/configuration/specialization/SpecializationViewPage'))
);

//  Location
export const LocationListPage = Loadable(
  lazy(() => import('../pages/dashboard/configuration/location/LocationListPage'))
);
export const LocationCreatePage = Loadable(
  lazy(() => import('../pages/dashboard/configuration/location/LocationCreatePage'))
);
export const LocationEditPage = Loadable(
  lazy(() => import('../pages/dashboard/configuration/location/LocationEditPage'))
);
export const LocationViewPage = Loadable(
  lazy(() => import('../pages/dashboard/configuration/location/LocationViewPage'))
);

//  Category
export const CategoryListPage = Loadable(
  lazy(() => import('../pages/dashboard/configuration/category/CategoryListPage'))
);
export const CategoryCreatePage = Loadable(
  lazy(() => import('../pages/dashboard/configuration/category/CategoryCreatePage'))
);
export const CategoryEditPage = Loadable(
  lazy(() => import('../pages/dashboard/configuration/category/CategoryEditPage'))
);
export const CategoryViewPage = Loadable(
  lazy(() => import('../pages/dashboard/configuration/category/CategoryViewPage'))
);

// Sub Category
export const SubCategoryListPage = Loadable(
  lazy(() => import('../pages/dashboard/configuration/sub-category/SubCategoryListPage'))
);
export const SubCategoryCreatePage = Loadable(
  lazy(() => import('../pages/dashboard/configuration/sub-category/SubCategoryCreatePage'))
);
export const SubCategoryEditPage = Loadable(
  lazy(() => import('../pages/dashboard/configuration/sub-category/SubCategoryEditPage'))
);
export const SubCategoryViewPage = Loadable(
  lazy(() => import('../pages/dashboard/configuration/sub-category/SubCategoryViewPage'))
);

// Super Sub Category
export const SuperSubCategoryListPage = Loadable(
  lazy(() => import('../pages/dashboard/configuration/super-sub-category/SuperSubCategoryListPage'))
);
export const SuperSubCategoryCreatePage = Loadable(
  lazy(() =>
    import('../pages/dashboard/configuration/super-sub-category/SuperSubCategoryCreatePage')
  )
);
export const SuperSubCategoryEditPage = Loadable(
  lazy(() => import('../pages/dashboard/configuration/super-sub-category/SuperSubCategoryEditPage'))
);
export const SuperSubCategoryViewPage = Loadable(
  lazy(() => import('../pages/dashboard/configuration/super-sub-category/SuperSubCategoryViewPage'))
);

// Feature Type
export const FeatureTypeCreateEditPage = Loadable(
  lazy(() => import('../pages/dashboard/configuration/feature-type/FeatureTypeCreateEditPage'))
);

// Brands
export const BrandListPage = Loadable(
  lazy(() => import('../pages/dashboard/configuration/brand/BrandListPage'))
);
export const BrandCreatePage = Loadable(
  lazy(() => import('../pages/dashboard/configuration/brand/BrandCreatePage'))
);
export const BrandEditPage = Loadable(
  lazy(() => import('../pages/dashboard/configuration/brand/BrandEditPage'))
);
// export const CategoryViewPage = Loadable(
//   lazy(() => import('../pages/dashboard/configuration/brand/CategoryViewPage'))
// );

// ENQUIRIES

// Job Application
export const JobApplicationListPage = Loadable(
  lazy(() => import('../pages/dashboard/enquiries/job-application/JobApplicationListPage'))
);
export const JobApplicationViewPage = Loadable(
  lazy(() => import('../pages/dashboard/enquiries/job-application/JobApplicationViewPage'))
);

// Appointment Enquiry
export const AppointmentEnquiryListPage = Loadable(
  lazy(() => import('../pages/dashboard/enquiries/appointment-enquiry/AppointmentEnquiryListPage'))
);
export const AppointmentEnquiryCreatePage = Loadable(
  lazy(() =>
    import('../pages/dashboard/enquiries/appointment-enquiry/AppointmentEnquiryCreatePage')
  )
);
export const AppointmentEnquiryEditPage = Loadable(
  lazy(() => import('../pages/dashboard/enquiries/appointment-enquiry/AppointmentEnquiryEditPage'))
);
export const AppointmentEnquiryViewPage = Loadable(
  lazy(() => import('../pages/dashboard/enquiries/appointment-enquiry/AppointmentEnquiryViewPage'))
);

// Contact Enquiry
export const ContactEnquiryListPage = Loadable(
  lazy(() => import('../pages/dashboard/enquiries/contact-enquiry/ContactEnquiryListPage'))
);
export const ContactEnquiryViewPage = Loadable(
  lazy(() => import('../pages/dashboard/enquiries/contact-enquiry/ContactEnquiryViewPage'))
);

// Career Enquiry
export const CareerEnquiryListPage = Loadable(
  lazy(() => import('../pages/dashboard/enquiries/career-enquiry/CareerEnquiryListPage'))
);
export const CareerEnquiryViewPage = Loadable(
  lazy(() => import('../pages/dashboard/enquiries/career-enquiry/CareerEnquiryViewPage'))
);

// Dealership Enquiry
export const DealershipEnquiryListPage = Loadable(
  lazy(() => import('../pages/dashboard/enquiries/dealership-enquiry/DealershipEnquiryListPage'))
);
export const DealershipEnquiryViewPage = Loadable(
  lazy(() => import('../pages/dashboard/enquiries/dealership-enquiry/DealershipEnquiryViewPage'))
);

// Service Enquiry
export const ServiceEnquiryListPage = Loadable(
  lazy(() => import('../pages/dashboard/enquiries/service-enquiry/ServiceEnquiryListPage'))
);
export const ServiceEnquiryViewPage = Loadable(
  lazy(() => import('../pages/dashboard/enquiries/service-enquiry/ServiceEnquiryViewPage'))
);

// Quotation Enquiry
export const QuotationEnquiryListPage = Loadable(
  lazy(() => import('../pages/dashboard/enquiries/quotation-enquiry/QuotationEnquiryListPage'))
);
export const QuotationEnquiryViewPage = Loadable(
  lazy(() => import('../pages/dashboard/enquiries/quotation-enquiry/QuotationEnquiryViewPage'))
);

// Product Enquiry
export const ProductEnquiryListPage = Loadable(
  lazy(() => import('../pages/dashboard/enquiries/product-enquiry/ProductEnquiryListPage'))
);
export const ProductEnquiryViewPage = Loadable(
  lazy(() => import('../pages/dashboard/enquiries/product-enquiry/ProductEnquiryViewPage'))
);

// Feedback
export const FeedbackListPage = Loadable(
  lazy(() => import('../pages/dashboard/enquiries/feedback/FeedbackListPage'))
);
export const FeedbackViewPage = Loadable(
  lazy(() => import('../pages/dashboard/enquiries/feedback/FeedbackViewPage'))
);

// DASHBOARD: USER
export const UserProfilePage = Loadable(lazy(() => import('../pages/dashboard/UserProfilePage')));
export const UserCardsPage = Loadable(lazy(() => import('../pages/dashboard/UserCardsPage')));
export const UserListPage = Loadable(lazy(() => import('../pages/dashboard/UserListPage')));
export const UserAccountPage = Loadable(lazy(() => import('../pages/dashboard/UserAccountPage')));
export const UserCreatePage = Loadable(lazy(() => import('../pages/dashboard/UserCreatePage')));
export const UserEditPage = Loadable(lazy(() => import('../pages/dashboard/UserEditPage')));

// MAIN
export const Page500 = Loadable(lazy(() => import('../pages/Page500')));
export const HomePage = Loadable(lazy(() => import('../pages/HomePage')));
